import React from 'react';
import { PointOfSale } from '@mui/icons-material';
import ReportLayout from '../Components/Reports/ReportLayout';

interface TypeReportProps {
  Entete: string;
  TypeGroup: string;
}

const FRTransactionCaisse: React.FC<TypeReportProps> = ({ Entete, TypeGroup }) => {
  return (
    <ReportLayout
      title={Entete}
      subtitle="Transactions caisse"
      icon={<PointOfSale />}
      endpoint="transaction-caisse"
      extraParams={{ Type: TypeGroup }}
      showClientRange={false}
      showDateRange={true}
      showAgence={true}
      extraFields={[
        {
          key: 'ListGroup',
          label: 'Sélection caisse',
          type: 'multiselect',
          fetchUrl: 'client-typegroupeclient',
          fetchParams: { TypeGroup },
          valueField: 'Code',
          labelField: 'Libelle',
          joinParam: 'ListGroup',
        },
        {
          key: 'SensOpe',
          label: 'Sens opération',
          type: 'select',
          options: [
            { value: 'A', label: 'A-VERSEMENTS ET RETRAITS' },
            { value: 'C', label: 'C-VERSMENTS' },
            { value: 'D', label: 'D-RETRAITS' },
          ],
        },
        { key: 'Min', label: 'Montant min', type: 'number', defaultValue: 0 },
        { key: 'Max', label: 'Montant max', type: 'number', defaultValue: 9999999999 },
      ]}
      paramTransform={(params) => ({
        ...params,
        Type: TypeGroup.concat(params.SensOpe || ''),
      })}
      fileNamePrefix="rapport_transaction_caisse"
    />
  );
};

export default FRTransactionCaisse;
